<template>
  <div class="table-page">
    <div class="cnt-header">
      <div class="top-btn"></div>
      <div class="search-input">
        <div class="filter-top" v-show="userInfo.is_admin">
          <label class="filter-label">筛选：</label>
          <el-select
            v-model="status"
            @clear="filterClear"
            @change="filterChange"
            clearable
            placeholder="审核状态"
          >
            <el-option
              v-for="item in statusOpts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="filter"
            @clear="filterClear"
            @change="filterChange"
            clearable
            placeholder="负责人"
          >
            <el-option
              v-for="item in filterOpts"
              :key="item.user_id"
              :label="item.username"
              :value="item.user_id"
            >
            </el-option>
          </el-select>
        </div>
        <el-input
          style="width: 355px"
          :clearable="true"
          placeholder="输入(会议名称/编号/单位/地点)检索项目"
          class="input-with-select"
          v-model="query"
          @keyup.enter.native="startQuery"
          @clear="clearInputVal"
        >
          <el-button slot="append" icon="el-icon-search" @click="startQuery"></el-button>
        </el-input>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="meet_name" label="会议名称"> </el-table-column>
      <el-table-column prop="meet_num" label="会议编号"> </el-table-column>
      <el-table-column prop="meet_time" label="会议时间"> </el-table-column>
      <el-table-column prop="company" label="承接单位"> </el-table-column>
      <el-table-column prop="meet_addr" label="会议地点"> </el-table-column>
      <el-table-column prop="user.username" label="负责人"> </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <div v-if="scope.row.verify_info.status === 1" style="color: #67c23a">
            <span>通过</span>&nbsp;<i class="el-icon-success"></i>
          </div>
          <el-tooltip v-else-if="scope.row.verify_info.status === -1" placement="bottom">
            <div style="color: #f56c6c">
              <span>拒绝</span>&nbsp;<i class="el-icon-error"></i>
            </div>
            <div slot="content">
              {{ scope.row.verify_info.remark }}
            </div>
          </el-tooltip>
          <div v-else style="color: #e6a23c">
            <span>审核中</span>&nbsp;<i class="el-icon-remove"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="提交时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            type="warning"
            v-if="scope.row.verify_info.status === 0"
            size="mini"
            @click="
              verifyStatement(scope.row.project_id, scope.row.verify_info.verify_id, 'final')
            "
            >进入审核</el-button
          >
          <el-button
            type="primary"
            v-else
            size="mini"
            @click="
              verifyStatement(scope.row.project_id, scope.row.verify_info.verify_id, 'final')
            "
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 25px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "../utils/utils.js";
export default {
  data() {
    return {
      filterOpts: [],
      filter: null,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      status: null,
      statusOpts: [
        { value: 1, label: "通过" },
        { value: -1, label: "拒绝" },
        { value: 0, label: "审核中" },
      ],
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
      },
      query: null,
    };
  },
  methods: {
    filterChange() {
      let that = this;
      that.loadVerifiers();
    },
    filterClear() {
      let that = this;
      that.loadVerifiers();
    },
    startQuery() {
      let that = this;
      that.currentPage = 1;
      if (that.query) {
        if (!that.query.trim()) {
          that.query = null;
        }
      }
      that.loadVerifiers();
    },
    clearInputVal() {
      let that = this;
      that.loadVerifiers();
    },
    verifyStatement(project_id, verify_id, typ) {
      let that = this;
      that.$router.push({
        path: "/verifiers/statements",
        query: {
          project_id: project_id,
          verify_id: verify_id,
          typ: typ,
        },
      });
    },
    handleCurrentChange(val) {
      let that = this;
      that.currentPage = val;
      that.loadVerifiers();
    },
    handleSizeChange(val) {
      let that = this;
      that.pageSize = val;
      that.loadVerifiers();
    },
    loadVerifiers() {
      let that = this;
      let reqUrl =
        that.host +
        "/api/final/verifiers?page=" +
        that.currentPage +
        "&page_size=" +
        that.pageSize;
      if (that.query) {
        reqUrl += "&query=" + that.query;
      }
      if (that.filter) {
        reqUrl += "&user_id=" + that.filter;
      }
      if (that.status === 1 || that.status === -1 || that.status === 0) {
        reqUrl += "&status=" + that.status;
      }
      that.$axios
        .get(reqUrl)
        .then((res) => {
          let results = res.data.results;
          that.total = results.total_count;
          that.tableData = results.projects;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    loadFilterOpts() {
      // 加载筛选选项
      let that = this;
      that.$axios
        .get(that.host + "/api/users/opts")
        .then((res) => {
          that.filterOpts = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
  },
  mounted() {
    let that = this;
    that.loadFilterOpts();
    getUserInfo().then((res) => {
      that.userInfo = res;
      if (that.userInfo.is_admin) {
        that.loadVerifiers();
      }
    });
  },
};
</script>

<style>
.filter-label {
  font-size: 14px;
  color: #e6a23c;
}
.cnt-header {
  position: relative;
  margin-bottom: 25px;
  line-height: 34px;
}
.filter-top {
  margin-right: 25px;
  display: inline-block;
}
.cnt-header .top-btn {
  display: inline-block;
}
.cnt-header .search-input {
  float: right;
}
.table-page {
  padding: 0 30px 0 30px;
}
</style>
